import {
    ADD_PRODUCT_IMAGE_SUCCESS,
    DELETE_PRODUCT_IMAGE_SUCCESS,
    FETCH_PRODUCT_IMAGES,
    FETCH_PRODUCT_IMAGES_FAILURE,
    FETCH_PRODUCT_IMAGES_SUCCESS,
    SET_HIGHLIGHTED_PRODUCT_IMAGE,
    SET_HIGHLIGHTED_PRODUCT_IMAGE_FAILURE,
    SET_HIGHLIGHTED_PRODUCT_IMAGE_SUCCESS,
} from 'store/actions/types';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    loading: false,
    offset: 0,
    size: 0,
    total: 0,
};

export default function productImages(state = initialState, action) {
    switch (action.type) {
        case FETCH_PRODUCT_IMAGES:
        case SET_HIGHLIGHTED_PRODUCT_IMAGE:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_PRODUCT_IMAGES_FAILURE:
        case SET_HIGHLIGHTED_PRODUCT_IMAGE_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_PRODUCT_IMAGES_SUCCESS:
            let convertResultsToData = {};

            if (action.response) {
                convertResultsToData = utils.mapToObject(action.response, (value) => {
                    return value.image_id;
                });
            }

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: convertResultsToData,
                }),
                loading: false,
                offset: action.response.offset,
                size: action.response.size,
                total: action.response.total,
            });

        case ADD_PRODUCT_IMAGE_SUCCESS:
            const addProductImage = Object.assign(
                {},
                state.data[action.productId],
                {
                    [action.response.image_id]: action.response,
                }
            );

            return Object.assign({}, state, {
                loading: false,
                data: Object.assign({}, state.data, {
                    [action.productId]: addProductImage,
                }),
            });

        case DELETE_PRODUCT_IMAGE_SUCCESS:
            const newProductImagesPayload = reducerHelper.removeItemFromObject(
                state.data[action.productId],
                action.imageId
            );

            return Object.assign({}, state, {
                loading: false,
                data: Object.assign({}, state.data, {
                    [action.productId]: newProductImagesPayload,
                }),
            });

        case SET_HIGHLIGHTED_PRODUCT_IMAGE_SUCCESS:
            const {
                productId,
                response,
            } = action;

            const previousHighlightedImage = utils.find(state.data[productId], (image) => {
                return image.is_highlighted;
            });

            let updatePreviousImage = {};

            if (previousHighlightedImage) {
                updatePreviousImage = response.image_id !== previousHighlightedImage.image_id && {
                    [previousHighlightedImage.image_id]: {
                        ...previousHighlightedImage,
                        is_highlighted: !previousHighlightedImage.is_highlighted,
                    },
                };
            }

            const updateHighlightedProductImage = Object.assign(
                {},
                state.data[productId],
                {
                    [response.image_id]: {
                        ...state.data[productId][response.image_id],
                        is_highlighted: response.is_highlighted,
                    },
                    ...updatePreviousImage,
                }
            );

            return Object.assign({}, state, {
                loading: false,
                data: Object.assign({}, state.data, {
                    [productId]: updateHighlightedProductImage,
                }),
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/products/productImagesReducer.js